import { supabase } from "@/infrastructure/supabase/client";
import type { OpenQuestionRow, Status } from "@/infrastructure/supabase/database.types";

export interface OpenQuestionFilters {
  status?: Status;
  ownerId?: string;
}

export const openQuestionsRepository = {
  async list(filters: OpenQuestionFilters = {}): Promise<OpenQuestionRow[]> {
    let q = supabase.from("open_questions").select("*").order("created_at", { ascending: true });
    if (filters.status) q = q.eq("status", filters.status);
    if (filters.ownerId) q = q.eq("owner_id", filters.ownerId);
    const { data, error } = await q;
    if (error) throw error;
    return data ?? [];
  },

  async byId(id: string): Promise<OpenQuestionRow | null> {
    const { data, error } = await supabase
      .from("open_questions")
      .select("*")
      .eq("id", id)
      .maybeSingle();
    if (error) throw error;
    return data;
  },

  async create(
    input: Omit<OpenQuestionRow, "id" | "created_at" | "updated_at">
  ): Promise<OpenQuestionRow> {
    const { data, error } = await supabase
      .from("open_questions")
      .insert(input)
      .select("*")
      .single();
    if (error) throw error;
    return data;
  },

  async update(id: string, patch: Partial<OpenQuestionRow>): Promise<OpenQuestionRow> {
    const { data, error } = await supabase
      .from("open_questions")
      .update(patch)
      .eq("id", id)
      .select("*")
      .single();
    if (error) throw error;
    return data;
  },

  async remove(id: string): Promise<void> {
    const { error } = await supabase.from("open_questions").delete().eq("id", id);
    if (error) throw error;
  },
};
